import React from 'react';
import { Link } from 'react-router-dom';
import {
  FiCheckSquare,
  FiFolder,
  FiFileText,
  FiMessageCircle,
  FiCamera,
  FiLock,
  FiStar,
} from 'react-icons/fi';
import { HomeKicker } from './HomePrimitives';
import { HomeReveal } from './HomeMotion';

const FEATURES = [
  {
    icon: <FiCheckSquare />,
    title: 'Task Management',
    text: 'Organize tasks, set priorities, and track progress to keep your team focused and on time.',
    to: '/products/task',
  },
  {
    icon: <FiCamera />,
    title: 'Snap Bill',
    text: 'Automate and streamline bills and expenses using our AI driven bill scanning module. Compare SOAs and generate LPOs.',
    to: '/products/snap-bill',
  },
  {
    icon: <FiFileText />,
    title: 'Documents',
    text: 'Store, organize, and share documents securely with role-based access and version history.',
    to: '/products/documents',
  },
  {
    icon: <FiFolder />,
    title: 'Projects',
    text: 'Plan, manage, and deliver projects on time with timelines, milestones, and team ownership.',
    to: '/products/projects',
  },
  {
    icon: <FiLock />,
    title: 'Credentials Vault',
    text: 'Store corporate and personal credentials in one encrypted vault with controlled sharing.',
    to: '/products/credentials-vault',
  },
  {
    icon: <FiMessageCircle />,
    title: 'Discussion Forum',
    text: 'Keep conversations with the work they belong to, so decisions stay searchable and aligned.',
    to: '/products/discussion-forum',
  },
];

const HomeFeaturesOverview = () => (
  <section className="home-section home-features" id="features">
    <div className="home-container">
      <HomeReveal className="home-center-head">
        <HomeKicker icon={<FiStar />}>Features</HomeKicker>
        <h2 className="home-section-title">Run your business. Not your software.</h2>
        <p className="home-section-sub">
          flowdo brings in various modules and automations under one platform
        </p>
      </HomeReveal>
      <div className="home-features-grid">
        {FEATURES.map((feature, index) => (
          <HomeReveal key={feature.title} delay={index * 0.07}>
            <Link to={feature.to} className="home-feature-card">
              <div className="home-feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.text}</p>
            </Link>
          </HomeReveal>
        ))}
      </div>
    </div>
  </section>
);

export default HomeFeaturesOverview;
